import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { webCam } from 'utils/webcamHelpers';
import PhotoButton from './PhotoButton';

const WebCamera = ({ onPhotoChoose }) => {
  const { t } = useTranslation();
  const [base64Img, setBase64Img] = useState('');
  const webCamRef = useRef(null);

  const onHandleTakePhoto = () => {
    const imageUrl = webCamRef.current.takeSnapshot();
    setBase64Img(imageUrl);
  };

  useEffect(() => {
    webCamRef.current = webCam({ videoId: 'video', canvasId: 'canvas' });
    webCamRef.current.startCamera();
  }, []);

  return (
    <div className='col-12 p-0 mb-12 mb-md-15'>
      <div className='d-flex justify-content-center'>
        <video id='video' width='500' height='375' autoPlay className={base64Img ? 'd-none' : 'rounded-10'} />
        <canvas id='canvas' width='500' height='375' className='d-none' />
        {base64Img && <img className='rounded-10' src={base64Img} alt='preview' />}
      </div>
      <div className='d-flex justify-content-center mt-5'>
        {!base64Img && (
          <div className='col-12 p-0'>
            <PhotoButton text={t('photo_option_take')} icon='camera' onClick={onHandleTakePhoto} />
          </div>
        )}
        {base64Img && (
          <>
            <div className='pr-8 col-6 pl-0'>
              <PhotoButton
                text={t('photo_option_take_new')}
                icon='picture'
                onClick={() => {
                  webCamRef.current.startCamera();
                  setBase64Img('');
                }}
              />
            </div>
            <div className='pl-8 col-6 pr-0'>
              <PhotoButton
                text={t('photo_option_choose_this')}
                icon='camera'
                onClick={() => onPhotoChoose(base64Img)}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WebCamera;
